/* ==========================================================================
   Oil Change Interval Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-oci]');
  if (!root) return;

  /* Base intervals in miles for a modern engine in normal service. */
  var BASE = { conv: 5000, blend: 6500, full: 9000, euro: 12000 };
  /* Maximum months regardless of mileage, because oil degrades with time. */
  var BASE_MONTHS = { conv: 6, blend: 9, full: 12, euro: 12 };

  /* Severe service multipliers. Short trips dominate everything else. */
  var TRIP = { short: 0.60, mixed: 0.90, long: 1.00 };
  var TOW_F = 0.80, DUST_F = 0.85, EXTREME_F = 0.85, IDLE_F = 0.85, TURBO_F = 0.85;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var base = BASE[input.oil] || BASE.full;
    var months = BASE_MONTHS[input.oil] || 12;
    if (!isFinite(input.miles) || input.miles <= 0) {
      return { ok: false, errors: ['Enter how many miles you drive per year.'] };
    }

    var factors = [];
    var f = TRIP[input.trips];
    if (!isFinite(f)) f = 0.9;
    if (input.trips === 'short') factors.push(['Short trips', TRIP.short]);
    else if (input.trips === 'mixed') factors.push(['Mixed trips', TRIP.mixed]);

    var mult = f;
    function apply(on, name, val) { if (on) { mult *= val; factors.push([name, val]); } }
    apply(input.tow, 'Towing or heavy load', TOW_F);
    apply(input.dust, 'Dust and gravel', DUST_F);
    apply(input.extreme, 'Extreme temperatures', EXTREME_F);
    apply(input.idle, 'Extended idling', IDLE_F);
    apply(input.turbo, 'Turbocharged', TURBO_F);

    var interval = Math.max(2500, base * mult);
    var intervalMonths = Math.max(3, months * Math.min(1, mult + 0.2));
    var byMiles = interval / input.miles * 12;
    var limitedBy = byMiles > intervalMonths ? 'time' : 'mileage';
    var perYear = Math.max(input.miles / interval, 12 / intervalMonths);

    var severe = mult < 0.85;
    var status;
    if (severe) {
      status = { key: 'soon', label: comma(Math.round(interval / 250) * 250) + ' miles',
                 note: 'Your driving counts as severe service. That is not unusual, most manufacturers define it broadly.' };
    } else {
      status = { key: 'good', label: comma(Math.round(interval / 250) * 250) + ' miles',
                 note: 'Normal service. Change by mileage or by ' + num(intervalMonths, 0) + ' months, whichever comes first.' };
    }

    var warnings = [];
    if (input.trips === 'short') {
      warnings.push('Short trips are the hardest thing you can do to engine oil. The oil never gets hot enough to drive off fuel and condensation, which is how sludge forms. This matters more than any other factor here.');
    }

    var rows = [
      { head: 'Interval' },
      { label: 'Base for this oil', value: comma(base) + ' miles' },
      { label: 'Severity multiplier', value: num(mult, 2) + 'x' },
      { label: 'Recommended', value: comma(Math.round(interval / 250) * 250) + ' miles' },
      { label: 'Or every', value: num(intervalMonths, 0) + ' months' },
      { label: 'Limited by', value: limitedBy },
      { label: 'Changes per year', value: num(perYear, 1) },
      { head: 'What reduced it' }
    ];
    if (factors.length) {
      factors.forEach(function (x) { rows.push({ label: x[0], value: num(x[1], 2) + 'x' }); });
    } else {
      rows.push({ label: 'Nothing', value: 'Normal service' });
    }
    rows.push({ head: 'If you switched oil' });
    ['conv','blend','full','euro'].forEach(function (k) {
      var names = { conv: 'Conventional', blend: 'Synthetic blend', full: 'Full synthetic', euro: 'Euro long life' };
      rows.push({ label: names[k] + (k === input.oil ? '  (yours)' : ''),
                  value: comma(Math.round(Math.max(2500, BASE[k] * mult) / 250) * 250) + ' mi' });
    });

    return {
      ok: true, errors: [], warnings: warnings, status: status,
      figures: [
        { label: 'Change every', value: comma(Math.round(interval / 250) * 250) + ' miles',
          sub: 'Or every ' + num(intervalMonths, 0) + ' months, whichever comes first. Yours is limited by ' + limitedBy + '.' },
        { label: 'Changes per year', value: num(perYear, 1),
          sub: 'At ' + comma(input.miles) + ' miles a year.' }
      ],
      rows: rows
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "oil",
          "key": "o",
          "type": "select"
      },
      {
          "name": "miles",
          "key": "m",
          "type": "number"
      },
      {
          "name": "trips",
          "key": "t",
          "type": "select"
      },
      {
          "name": "tow",
          "key": "tw",
          "type": "checkbox"
      },
      {
          "name": "dust",
          "key": "du",
          "type": "checkbox"
      },
      {
          "name": "extreme",
          "key": "ex",
          "type": "checkbox"
      },
      {
          "name": "idle",
          "key": "id",
          "type": "checkbox"
      },
      {
          "name": "turbo",
          "key": "tb",
          "type": "checkbox"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-oci__figure">'
        + '<div class="pc-oci__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-oci__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-oci__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-oci__row pc-oci__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-oci__row">'
        + '<span class="pc-oci__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-oci__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_OCI = { compute: compute };
})();
